import { DynamicFormV2Palette } from "@mui/material";

export type FormButtonComponentTokenType = {
  solid: {
    backgroundColor: string;
    hoverBackgroundColor: string;
    color: string;
  };
  tonal: {
    backgroundColor: string;
    hoverBackgroundColor: string;
    color: string;
  };
  outline: {
    backgroundColor: string;
    hoverBackgroundColor: string;
    borderColor: string;
    color: string;
  };
  ghost: {
    backgroundColor: string;
    hoverBackgroundColor: string;
    color: string;
  };
  rounded: {
    backgroundColor: string;
    hoverBackgroundColor: string;
    borderColor: string;
    color: string;
    hoverColor: string;
    focusBorderColor: string;
    focusBackgroundColor: string;
    selectedBackgroundColor: string;
    selectedBorderColor: string;
    selectedColor: string;
  };
};

export const assignButtonComponentTokens = (formsPalette: DynamicFormV2Palette["forms"], mode: "light" | "dark") => {
  const isLightMode = mode === "light";

  return {
    solid: {
      backgroundColor: isLightMode ? formsPalette.surface.intense : formsPalette.surface.reverse,
      hoverBackgroundColor: formsPalette.surface.hover.intense,
      color: formsPalette.text.reverse,
    },
    tonal: {
      backgroundColor: isLightMode ? formsPalette.surface.moderate : formsPalette.surface.reverse,
      hoverBackgroundColor: isLightMode ? formsPalette.surface.hover.moderate : formsPalette.surface.hover.intense,
      color: isLightMode ? formsPalette.text.intense : formsPalette.text.reverse,
    },
    outline: {
      backgroundColor: formsPalette.surface.supershy,
      hoverBackgroundColor: formsPalette.surface.hover.quiet,
      borderColor: formsPalette.border.moderate,
      color: formsPalette.text.intense,
    },
    ghost: {
      backgroundColor: "transparent",
      hoverBackgroundColor: isLightMode ? formsPalette.surface.hover.moderate : formsPalette.surface.hover.quiet,
      color: formsPalette.text.intense,
    },
    rounded: {
      backgroundColor: isLightMode ? formsPalette.surface.supershy : formsPalette.surface.intense,
      hoverBackgroundColor: formsPalette.surface.hover.quiet,
      borderColor: isLightMode ? formsPalette.border.quiet : formsPalette.border.brand,
      color: isLightMode ? formsPalette.text.moderate : formsPalette.text.intense,
      hoverColor: formsPalette.text.intense,
      focusBorderColor: formsPalette.border.moderate,
      focusBackgroundColor: isLightMode ? formsPalette.surface.supershy : formsPalette.surface.hover.quiet,
      selectedBackgroundColor: isLightMode ? formsPalette.surface.moderate : formsPalette.surface.hover.quiet,
      selectedBorderColor: isLightMode ? formsPalette.border.brand : formsPalette.border.intense,
      selectedColor: formsPalette.text.intense,
    },
  } as FormButtonComponentTokenType;
};
